import {ReturnReason} from 'coreStore/data/orders/types';

/**
 * Represents ReturnReasonModel
 */
class ReturnReasonModel {
	private returnReason: ReturnReason;

	/**
	 * @construct
	 * @param {ReturnReason} returnReason - return reason
	 */
	constructor(returnReason) {
		this.returnReason = returnReason;
	}

	/**
	 * Provides return reason label
	 * @returns {string} - return reason label
	 */
	getLabel(): string {
		return this.returnReason.label;
	}

	/**
	 * Provides return reason value
	 * @returns {string} - return reason value
	 */
	getValue(): string {
		return this.returnReason.value;
	}

}

export default ReturnReasonModel;
